// extracted by mini-css-extract-plugin
module.exports = {"root":"📦ConfirmUnlink__root--3R7PT","colorDanger":"📦ConfirmUnlink__colorDanger--2qE-H"};